import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import styled from "styled-components";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { calcRem } from "styles/theme";
import { ModalRadioItem } from "styles/ModalRadioCommonStyled";

export const RadioWrapper = styled.div<{ level: LEVEL_TYPE }>`
  ${FLEX.FlexBetweenStart};
  gap: 15px;
  max-width: 100%;
  color: ${({ theme }) => theme.COLORS.WHJITE};

  ${({ level }) =>
    level === LEVEL_TYPE.EU &&
    `
    width: 430px;
    flex-direction: column;
  `}

  @media (max-height: 700px) and (min-width: ${mediaQuery.mobileMax}px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
`;

export const RadioItem = styled(ModalRadioItem)<{
  level: LEVEL_TYPE;
}>`
  position: relative;
  ${FLEX.FlexStartCenter};
  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  ${({ level }) =>
    level === LEVEL_TYPE.CP &&
    `
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  `}

  .report-radio-item {
    ${({ level }) =>
      level === LEVEL_TYPE.CP &&
      `
      padding: 10px 0 5px;
    `}
  }
  .report-item-link {
    font-size: ${calcRem(12)};
    font-weight: 500;
    padding-top: 15px;
    color: ${({ theme, checked }) =>
      checked ? theme.COLORS.SELECTED : theme.COLORS.TEXT};
    text-transform: uppercase;
    svg {
      vertical-align: middle;
    }
  }
  @media (max-height: 700px) and (min-width: ${mediaQuery.mobileMax}px) {
    height: 100%;
  }
`;
